import { app } from '../../../../../../app';
import { Controller } from './backup-codes.controller';

app.component('companyUserDirectoriesUserBackupCodes', {
    bindings: {
        companyId: '<',
        currentCompany: '<',
        companyUser: '<',
        hardToken: '<',
        userSettings:'<'
    },
    controller: Controller,
    templateUrl: require('./backup-codes.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-user/details/backup-codes/backup-codes.component.js